import { IntlShape } from 'react-intl/src/types';

export const validationMessages = {
  phoneNumber: 'Het telefoonummer is niet juist ingevuld. Probeer het opnieuw.',
  zipCode: 'De postcode is niet juist ingevuld. Probeer het opnieuw.',
  email: 'Het e-mailadres is niet juist ingevuld. Probeer het opnieuw.',
  required: 'Dit is verplicht om in te vullen.',
  minLength: (min: number) => `Minimaal ${min} tekens`,
  maxLength: (max: number) => `Maximaal ${max} tekens`,
  min: (min: number) => `Hier geldt een minimaal van ${min}`,
  max: (max: number) => `Hier geldt een maximaal van ${max}`,
  iban: 'Ongeldig IBAN',
  date: 'De datum is niet juist ingevuld. Probeer het in het formaat dd/mm/jjjj',
  minimumAge: 'Je kunt deze berekening alleen gebruiken als je 18 jaar of ouder bent.',
  maximumAge: 'De maximale leeftijd is bereikt.',
  minimumIncome: 'Het bruto jaarinkomen moet hoger zijn dan € 1000,-'
};

export const validationMessagesTranslated = (intl: IntlShape) => {
  return {
    required: intl.formatMessage({
      id: 'validation.required',
      defaultMessage: 'Dit is verplicht om in te vullen.'
    }),
    dateMustBeInTheFuture: intl.formatMessage({
      id: 'validation.dateMustBeInTheFuture',
      defaultMessage: 'De datum moet in de toekomst liggen'
    }),
    date: intl.formatMessage({
      id: 'validation.date',
      defaultMessage: 'De datum is niet juist ingevuld. Probeer het in het formaat dd/mm/jjjj'
    }),
    zipCode: intl.formatMessage({
      id: 'validation.zipCode',
      defaultMessage: 'De postcode is niet juist ingevuld. Probeer het opnieuw.'
    }),
    min: (min: number) =>
      intl.formatMessage(
        {
          id: 'validation.min',
          defaultMessage: 'Hier geldt een minimaal van {min}'
        },
        { min }
      )
  };
};
